module.exports = __webpack_public_path__ + "media/allCheck.833c4be3.mp3";